function Skills() {
    return (
      <div id="presentation" className="mt-12">
          <h2 className="text-2xl font-bold sm:text-3xl mb-6">
            My stacks
          </h2>
        <ul className="grid grid-cols-3 gap-4 sm:grid-cols-4 font-light">
            <li className="flex items-center space-x-2">
                <i className="devicon-nodejs-plain"></i><span>NodeJS</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-typescript-plain"></i><span>TypeScript</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-react-plain"></i><span>React</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-selenium-plain"></i><span>Selenium</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-python-plain"></i><span>Python</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-heroku-plain"></i><span>Heroku</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-docker-plain"></i><span>Docker</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-git-plain"></i><span>Git</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-github-plain"></i><span>Github</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-figma-plain"></i><span>Figma</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-firebase-plain"></i><span>Firebase</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-filezilla-plain"></i><span>Filezilla</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-vscode-plain"></i><span>VSCode</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-xcode-plain"></i><span>Xcode</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-swift-plain"></i><span>Swift</span> 
            </li>
            <li className="flex items-center space-x-2">
                <i className="devicon-xcode-plain"></i><span>Xcode</span> 
            </li>
        </ul>
      </div>
    );
  }
  
  export default Skills;
  